import React from 'react';
import { Info } from 'lucide-react';

interface InfoNoticeProps {
  children: React.ReactNode;
}

export const InfoNotice: React.FC<InfoNoticeProps> = ({ children }) => {
  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-300 dark:border-blue-700/30 rounded-lg p-4 flex items-start gap-3">
      <Info className="w-5 h-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
      <div className="text-sm text-blue-900 dark:text-blue-300">
        <span className="font-semibold">Info: </span>
        {children}
      </div>
    </div>
  );
};
